<template>
	<div>
		<v-container>
			<app-table
				selectable
				class="mt-1 is-not-selectable"
				name="resources"
				:columns="columns"
				:rows="actions"
				:check-all="checkAll"
				@on-selected-all="allIsSelected"
				@row-is-selected="rowIsSelected"
			>
				<template slot="rows" slot-scope="props">
					<td>
						{{ getName(props.row) }}
					</td>
					<td>
						{{ props.row.code }}
					</td>
					<td>
						{{ props.row.url }}
					</td>
					<td class="px-2 py-2">
						<v-text-field
							solo
							hide-details
							v-model="props.row.fragMovil"
						/>
					</td>
					<td class="px-2 py-2">
						<v-text-field
							solo
							hide-details
							v-model="props.row.position"
						/>
					</td>
				</template>
			</app-table>
		</v-container>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				:is-loading="false"
				@accept-button-clicked="$emit('save-data')"
				@cancel-button-clicked="$emit('close-modal')"
			/>
		</section>
	</div>
</template>

<script>
import lib from '@/lib';

const { getDeeper } = lib;

function getName(row) {
	return getDeeper('languages', 'es', 'name')(row);
}

function allIsSelected(value) {
	this.checkAll = value;
	this.$emit('select-all', value);
}

function rowIsSelected(row) {
	this.$emit('row-is-selected', row);
}

function data() {
	return {
		checkAll: false,
		columns: [
			{ id: 1, name: 'Nombre', checked: true, visible: true },
			{ id: 2, name: 'Código', checked: true, visible: true },
			{ id: 3, name: 'URL Web', checked: true, visible: true },
			{ id: 4, name: 'Frag. Movil', checked: true, visible: true },
			{ id: 5, name: 'Posición', checked: true, visible: true },
		],
	};
}

export default {
	name: 'actions-bar',
	data,
	methods: {
		allIsSelected,
		rowIsSelected,
		getName,
	},
	props: {
		actions: {
			default: () => [],
			type: Array,
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/components/actions/actions-bar.vue